import { mapState } from 'vuex'
import fields from '../../db/main-fields'

export default {
  data () {
    return {
      filterFields: ['Name and surname', 'Position'],
      s3url: process.env.VUE_APP_AWS_S3_URL,
      countryVars: ''
    }
  },

  computed: {
    ...mapState(['basic', 'options', 'addons', 'marketplaces', 'socials', 'template']),
    image () {
      return this.basic.image.link
    },
    isEmpty () {
      return this.basic.fields.every((item) => item.value.length === 0)
    },
    mainFields () {
      if (this.isEmpty) {
        return fields.basicPlaceholder.filter((item) => this.filterFields.includes(item.name))
      }
      return this.basic.fields.filter((item) => this.filterFields.includes(item.name))
    },
    otherFields () {
      if (this.isEmpty) {
        return fields.basicPlaceholder.filter(
          (item) => !this.filterFields.includes(item.name)
        )
      }
      return this.basic.fields.filter(
        (item) => !this.filterFields.includes(item.name)
      )
    },
    showAvatar () {
      return this.options.avatar.show
    },
    fontBase () {
      return {
        fontSize: '14px',
        fontFamily: 'Arial,Helvetica,sans-serif',
        color: '#627282',
        lineHeight: '22px'
      }
    },
    fontLink () {
      return {
        fontSize: '14px',
        fontFamily: 'Arial,Helvetica,sans-serif',
        color: '#1662C6',
        lineHeight: '22px',
        textDecoration: 'none'
      }
    },
    setCountry () {
      this.countryVars = this.marketplaces.marketplaces.filter((key) => { return key.lang == this.basic.marketplace.country })
    }
  },
  methods: {
    formatLink (value) {
      return /^https?/.test(value) ? value : `http://${value}`
    },
    isAdded (name) {
      return this.addons.installed.findIndex((i) => i.name === name) > -1
    }
  }
}
